import ApiService from "@/core/services/api.service";
import querystring from "querystring";
import { responseError } from '@/core/mixin/shared'

const BASE = "region";

export const MODULE_NAME = `regionModule`;
export const BASE_URL = `api/regions`;
export const LOADING = `${BASE}/LOADING`;
export const ERROR = `${BASE}/ERROR`;
export const SUCCESS = `${BASE}/SUCCESS`;
export const ITEMS = `${BASE}/ITEM`;
export const ITEMS_ALL = `${BASE}/ITEMS_ALL`;
export const ITEM = `${BASE}/CURRENT_ITEM`;

export const SET_LOADING = `${BASE}/M/LOADING`;
export const SET_ERROR = `${BASE}/M/ERROR`;
export const SET_SUCCESS = `${BASE}/M/SUCCESS`;
export const SET_ITEMS = `${BASE}/M/ITEMS`;
export const SET_ITEMS_ALL = `${BASE}/M/ITEMS_ALL`;
export const SET_ITEM = `${BASE}/M/CURRENT_ITEM`;
export const RESET_VALUES = `${BASE}/M/RESET_VALUES`;

// ACTIONS
export const GET_ITEMS = `${BASE}/GET_ITEMS`;
export const GET_ALL_ITEMS = `${BASE}/GET_ALL_ITEMS`;
export const GET_ITEM = `${BASE}/GET_ITEM`;
export const CREATE_ITEM = `${BASE}/CREATE_ITEM`;
export const UPDATE_ITEM = `${BASE}/UPDATE_ITEM`;
export const DELETE_ITEM = `${BASE}/DELETE_ITEM`;

const state = {
  items: null,
  items_all: null,
  item: {},
  loading: false,
  error: null,
  success: null
};

const getters = {
  [LOADING]: state => {
    return state.loading;
  },
  [ERROR]: state => {
    return state.error;
  },
  [SUCCESS]: state => {
    return state.success;
  },
  [ITEMS]: state => {
    return state.items;
  },
  [ITEMS_ALL]: state => {
    return state.items_all;
  },
  [ITEM]: state => {
    return state.item;
  }
};

const mutations = {
  [SET_LOADING]: (state, payload) => {
    state.loading = payload;
  },
  [SET_ERROR]: (state, payload) => {
    state.error = responseError(payload);
  },
  [SET_ITEMS]: (state, payload) => {
    state.items = payload;
  },
  [SET_SUCCESS]: (state, payload) => {
    state.success = payload;
  },
  [SET_ITEM]: (state, payload) => {
    state.item = payload;
  },
  [SET_ITEMS_ALL]: (state, payload) => {
    state.items_all = payload;
  },
  [RESET_VALUES]: state => {
    state.success = null;
    state.error = null;
    state.loading = false;
    state.item = {};
    state.items = [];
  }
};

const actions = {
  [GET_ALL_ITEMS]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let filters = payload.filters;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    if (filters) {
      url = `${url}?` + querystring.stringify(filters);
    }
    return ApiService.get(url)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_ITEMS_ALL, response.data);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [GET_ITEMS]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let filters = payload.filters;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    if (filters) {
      url = `${url}?` + querystring.stringify(filters);
    }
    return ApiService.get(url)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_ITEMS, response.data);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [GET_ITEM]: (context, payload) => {
    let url = payload.url || BASE_URL;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    return ApiService.get(url)
        .then(response => {
          context.commit(SET_ITEM, response.data);
          context.commit(SET_LOADING, false);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [UPDATE_ITEM]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let contents = payload.contents;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    context.commit(SET_SUCCESS, false);
    ApiService.put(url, contents)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_ITEM, response.data);
          context.commit(SET_SUCCESS, true);
          context.commit(SET_ITEMS_ALL, null);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [CREATE_ITEM]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let contents = payload.contents;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    context.commit(SET_SUCCESS, false);
    ApiService.post(url, contents)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_SUCCESS, true);
          context.commit(SET_ITEM, response.data);
          context.commit(SET_ITEMS_ALL, null);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [DELETE_ITEM]: (context, payload) => {
    let url = payload.url || BASE_URL + "/" + payload.id;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    context.commit(SET_SUCCESS, false);
    ApiService.delete(url)
        .then(() => {
          context.commit(SET_LOADING, false);
          context.commit(SET_SUCCESS, true);
          context.commit(SET_ITEM, {});
          context.commit(SET_ITEMS_ALL, null);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
